import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';

const initialState = {
	notifications: [],
	notificationId: null,
};

export const salesmanNotiySlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotifications: (state, { payload }) => {
			state.notifications = payload;
		},
		filterNotifications: (state, { payload }) => {
			const filteredNotifications = state.notifications.filter((d) => d.id !== payload);

			state.notifications = filteredNotifications;
		},
		setNotificationId: (state, { payload }) => {
			state.notificationId = payload;
		},
	},
});

export const { setNotifications, filterNotifications, setNotificationId } =
	salesmanNotiySlice.actions;

export const getNotifications = (salesmanId) => async (dispatch, getState) => {
	const invoice_date = getState()?.app?.invoiceDate;

	console.log('getNotifications');

	const CREDENTIALS = {
		url: `/notifications`,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		if (response) {
			dispatch(setNotifications(response.data));
		}

		return response;
	});
};
export const deleteNotifications = (data) => async (dispatch) => {
	const CREDENTIALS = {
		url: `/notifications/${data}`,
		method: 'delete',
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(filterNotifications(data));

		return response;
	});
};

export default salesmanNotiySlice.reducer;
